import { InferType, object, string } from 'yup';
import i18n from '@components/i18n';
import { formValuesSchema as baseSchema } from '../HealthPolicyClaim/schema';

export const formValuesSchema = baseSchema.omit(['claimType']).concat(
  object().shape({
    claimType: string().default('').required(i18n.t('validation:required')),
  })
) as typeof baseSchema;

export type FormValues = InferType<typeof formValuesSchema>;
